export default __webpack_public_path__ + "static/media/FiberCablesImg.2657c551.jpg";